// The membership tiers a picker may offer.
//
// state.objects.membership_tier holds every tier the page has been sent: the customer's own,
// tiers of other stores visited in the session, the list the account page loads. Offering all
// of it shows tiers the merchant switched off for the store, so each picker asks for the tiers
// the server named for its own context instead.

// The default tier first and NoMembershipTiers last, the rest in the order they are cached (the
// sort is stable). The default is the tier a new bottle starts on, which the store names; the
// merchant's flagged default stands in where the store is not loaded.
export function sortMembershipTiers(tiers, defaultTierId = null) {
  const defaultTier =
    (defaultTierId != null && tiers.find((tier) => String(tier.id) === String(defaultTierId))) ||
    tiers.find((tier) => tier.attributes.is_default)
  const position = (tier) => {
    if (tier.attributes.type === 'NoMembershipTier') return 2
    return tier === defaultTier ? 0 : 1
  }
  return [...tiers].sort((x, y) => position(x) - position(y))
}

const relationshipIds = (relationshipData) => (relationshipData || []).map((relationship) => relationship.id)

function tiersWithIds(state, ids, defaultTierId = null) {
  const offered = new Set(ids.map(String))
  const tiers = Object.values(state.objects?.membership_tier || {}).filter((tier) => offered.has(String(tier.id)))
  return sortMembershipTiers(tiers, defaultTierId)
}

// Checkout: the tiers the bottle's store is paired with. Two requests can name them, the store
// itself and the tier list fetched for the bottle, and not every page makes both.
export function checkoutMembershipTiers(state, bottleId) {
  const bottle = state.objects?.bottle?.[bottleId]
  const store = state.objects?.store?.[bottle?.relationships?.store?.data?.id]
  return tiersWithIds(
    state,
    [
      ...relationshipIds(store?.relationships?.membership_tiers?.data),
      ...(state.bottleMembershipTierIds?.[bottleId] || [])
    ],
    store?.attributes?.new_bottle_membership_tier_id
  )
}

// Account page: the tiers the server lists as possible for this customer.
export function accountMembershipTiers(state, customer) {
  return tiersWithIds(state, relationshipIds(customer?.relationships?.possible_membership_tiers?.data))
}
